import Marquee3k from 'marquee3000';

$(function () {
  Marquee3k.init()
})
